import React from 'react'
import { Box } from '@mui/material'

function SpacerBlock({id,type,properties}) {
  return (
    <Box
            sx={{
              height: properties.height || '40px',
              width: '100%'
            }}
          />
  )
}

export default SpacerBlock